import React, { useState } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Header2 from '../Common/Header2';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import { projects } from '../Elements/ProjectsData';
import ReactPlayer from 'react-player';

const ProjectDetail = () => {
    const { title } = useParams();
    const [videoUrl, setVideoUrl] = useState(null); 
    const handleVideoClick = (url) => {
        setVideoUrl(url); // Set the video URL to show in the modal
    };
    const project = projects.find(
        (p) => p.title.toLowerCase().replace(/\s+/g, '-') === title
    );

    if (!project) {
        return (
            <>
                <Header2 />
                <div className="page-content">
                    <Banner title="Project Not Found" pagename="Error" />
                    <div className="container text-center p-t80 p-b80">
                        <h3>Sorry, the project you are looking for does not exist.</h3>
                        <NavLink to="/" className="btn btn-primary m-t20">Go Back to Projects</NavLink>
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    

    return (
        <>
            <Header2 />
            <div className="page-content">
                <Banner
                    title={project.title}
                    pagename="Project Detail"
                    description={project.description || "No description available."}
                    bgimage={project.bgImage}
                />

                {/* SECTION CONTENT START */}
                <div className="section-full p-tb80 inner-page-padding stick_in_parent">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 col-md-12">
                                <div className="project-detail-outer row">
                                    {project.image1 && (
                                        <div className="col-md-6">
                                            <div className="project-detail-pic m-b30">
                                                <div className="sx-media">
                                                    <img src={project.image1} alt={project.title} />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {project.image2 && (
                                        <div className="col-md-6">
                                            <div className="project-detail-pic m-b30">
                                                <div className="sx-media">
                                                    <img src={project.image2} alt={project.title} />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    
                                    {project.image3 && (
                                        <div className="col-md-6">
                                            <div className="project-detail-pic m-b30">
                                                <div className="sx-media">
                                                    <img src={project.image3} alt={project.title} />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {project.image4 && (
                                        <div className="col-md-6">
                                            <div className="project-detail-pic m-b30">
                                                <div className="sx-media">
                                                    <img src={project.image4} alt={project.title} />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {project.image5 && (
                                        <div className="col-md-6">
                                            <div className="project-detail-pic m-b30">
                                                <div className="sx-media">
                                                    <img src={project.image5} alt={project.title} />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {project.image6 && (
                                        <div className="col-md-6">
                                            <div className="project-detail-pic m-b30">
                                                <div className="sx-media">
                                                    <img src={project.image6} alt={project.title} />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    
                                    {project.videoUrl && (
                                        <div className="col-md-12">
                                            <div className="sx-box">
                                                <div className="sx-thum-bx sx-img-overlay1 sx-img-effect yt-thum-box">
                                                    <img src={project.videoImage} alt={project.title} />
                                                    <button
                                                        onClick={() => handleVideoClick(project.videoUrl)} // Open video in modal
                                                        className="play-now"
                                                    >
                                                        <i className="icon fa fa-play" />
                                                        <span className="ripple" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Video Modal */}
                            <div className="modal fade" id="myModal" role="dialog">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-body">
                                            {/* Displaying the video in a ReactPlayer */}
                                            {videoUrl && <ReactPlayer url={videoUrl} playing controls />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12">
                                {/* sticky_column */}
                                <div className="project-detail-containt-2">
                                    <div className="bg-white text-black p-a20 shadow">
                                        <div className="product-block bg-gray p-a30 m-b30">
                                            <ul>
                                                <li>
                                                    <h4 className="sx-title">Client</h4>
                                                    <p>{project.client || 'N/A'}</p>
                                                </li>
                                                <li>
                                                    <h4 className="sx-title">Location</h4>
                                                    <p>{project.address || 'N/A'}</p>
                                                </li>
                                                <li>
                                                    <h4 className="sx-title">Value</h4>
                                                    <p>{project.valu || 'N/A'}</p>
                                                </li>
                                                <li>
                                                    <h4 className="sx-title">Status</h4>
                                                    <p>{project.status || 'N/A'}</p>
                                                </li>
                                            </ul>
                                        </div>
                                        {/* <h4>Landscape plans for drainage problems may also entail planting beds away from the home’s foundation.</h4> */}
                                        <p> {project.description || 'N/A'}</p>
                                        <div className="m-b0">
                                            <div className="sx-divider divider-1px  bg-black"><i className="icon-dot c-square" /></div>
                                        </div>
                                        {/* <ul className="social-icons social-square social-darkest m-b0">
                                            <li><a href="https://www.facebook.com" target="_blank" className="fa fa-facebook" /></li>
                                            <li><a href="https://twitter.com" target="_blank" className="fa fa-twitter" /></li>
                                            <li><a href="https://in.linkedin.com" target="_blank" className="fa fa-linkedin" /></li>
                                            <li><a href="https://rss.com" target="_blank" className="fa fa-rss" /></li>
                                            <li><a href="https://www.youtube.com" target="_blank" className="fa fa-youtube" /></li>
                                            <li><a href="https://www.instagram.com" target="_blank" className="fa fa-instagram" /></li>
                                        </ul> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* SECTION CONTENT END  */}

            </div>
            <Footer />
        </>
    );
};

export default ProjectDetail;
